/**
 * One shape and one colour for a source, everywhere it appears.
 *
 * A source shows up at four moments — what will be read (the checklist), what
 * is being read (the reading pips), what a claim rests on (the citation marker
 * in the answer) and what was read (the footer count). Giving those four
 * different treatments made them look like four unrelated things, when the
 * whole point is that they are one thing at four moments.
 *
 * Emerald rather than the page's orange: orange is the action colour here (the
 * composer ring, both CTA doors, the founder actions), and provenance is not an
 * action. Keeping sources off that colour leaves exactly one thing on the
 * screen asking to be clicked.
 *
 * Semi-rect (5px), not a full pill: it matches the prototype's citation chip,
 * and a fully-round marker sitting inline in a sentence reads as a bullet
 * rather than a footnote.
 */

/** The inline citation marker in the answer body. */
export const CITATION_PILL = 'rounded-[5px] border border-emerald-500/35 px-1 text-emerald-500'

/**
 * A deck citation whose slide `reattest` has not confirmed yet. Grey, not
 * red or a strikethrough: it is a genuinely open question, not a failure.
 *
 * There is no "contested" variant: a bullet `reattest` could not confirm is
 * retracted from the text outright (`retractBullets` in `citations.ts`)
 * rather than kept on screen with a warning colour, so this pill only ever
 * resolves pending → verified, never pending → failed.
 */
export const CITATION_PILL_PENDING = 'rounded-[5px] border border-border px-1 text-muted-foreground'

/** The larger standalone pill: checklist rows, reading pips, the footer count. */
export const SOURCE_PILL =
  'rounded-[5px] border border-emerald-500/35 px-2 py-0.5 font-mono text-[10px] uppercase tracking-wide text-emerald-500'
